import { glyphPath, type SnapGlyph } from '../snap';

export function LegendGlyph({ glyph }: { glyph: SnapGlyph }) {
  const d = glyphPath(glyph, 7, 7, 1.2);
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" aria-hidden="true">
      <path className={glyph === 'dot' ? 'd' : 'g'} d={d} />
    </svg>
  );
}
